export default __webpack_public_path__ + "static/media/safari-phone-3.1f5fc961.jpg";